import React from 'react'
import styled from 'styled-components';

const BackButton = styled.button`
    position: relative;
    
    align-items: center;
    display: flex;
    height: 32px;
    justify-content: center;
    margin-bottom: 48px;
    padding: 0;
    width: fit-content;

    background: transparent;
    color: var(--brand);
    border: 0;
    border-radius: 24px;
    cursor: pointer;
    font-size: 14px;
    font-weight: 500;
    outline: 0;
    transition: all .4s ease-in-out;
    &:hover {
        color: var(--green2);
    }
    span {
        display: inline-block;
        margin-left: 8px;
        line-height: 20px;
    }
`;

const BackButtonWithIcon = ({children, onClick}) => {
    const arrIcon = <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
            <g clipPath="url(#clip0)">
            <rect width="24" height="24" rx="12" fill="#5AE4AA"/>
            <path d="M5 11.6706L10.7298 6L11.9792 7.23657L8.33673 10.8173H19L18.9871 12.5256H8.3376L11.9792 16.1047L10.7298 17.3413L5 11.6706Z" fill="#242424"/>
            </g>
            <defs>
            <clipPath id="clip0">
            <rect width="24" height="24" fill="white"/>
            </clipPath>
            </defs>
        </svg>

    return (
        <BackButton onClick={onClick}>
            {arrIcon}
            <span>{children}</span>
        </BackButton>
    )
    
}

export default BackButtonWithIcon;